import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Segment, Table, Dropdown } from "semantic-ui-react";
import _ from "lodash";
import Case from "../dialogs/Case";
import QuickTips from "../dialogs/QuickTips";
import CoverageArea from "../dialogs/CoverageArea";

class FormHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCaseDialog: false,
      currentCaseData: null,
      showCoverageDialog: false,
      showQuickTipsDialog: false,
    };
  }

  componentDidMount() {
    this.loadOptions(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadOptions(nextProps);
  }

  loadOptions = (props) => {
    const options = [
      { key: "case_-2", value: -2, text: "Add to Case" },
      { key: "case_-1", value: -1, text: "Create New Case" },
    ];
    const { userCases } = props;
    if (
      userCases &&
      userCases.Folders !== undefined &&
      userCases.Folders.length > 0
    ) {
      _.forEach(userCases.Folders, (folder) => {
        const folderCode = parseInt(folder.folderCode, 10);
        options.push({
          key: `case_${folderCode}`,
          value: folderCode,
          text: folder.folderName,
        });
      });
    }
    let selectedOption;
    if (localStorage.selectedFolderCode !== undefined) {
      selectedOption = _.find(
        options,
        (o) => o.value === parseInt(localStorage.selectedFolderCode, 10)
      );
      if (selectedOption)
        localStorage.selectedFolderCode = selectedOption.value;
    }
    this.setState({ options, currentOption: selectedOption || options[0] });
  };

  dialogClose = () => {
    this.setState({ showCaseDialog: false });
  };

  openCoverageAreaDialog = () => {
    this.setState({ showCoverageDialog: true });
  };

  closeCoverageAreaDialog = () => {
    this.setState({ showCoverageDialog: false });
  };

  openQuickTipsDialog = () => {
    this.setState({ showQuickTipsDialog: true });
  };

  closeQuickTipsDialog = () => {
    this.setState({ showQuickTipsDialog: false });
  };

  openCoverageAreaDialog = () => {
    this.setState({ showCoverageDialog: true });
  };

  closeCoverageAreaDialog = () => {
    this.setState({ showCoverageDialog: false });
  };

  caseChanged = (e, data) => {
    if (data.value === -1) {
      this.setState({ showCaseDialog: true, currentCaseData: null });
    } else if (data.value !== -2 && this.props.userCases) {
      const currentCaseData = _.find(
        this.props.userCases.Folders,
        (f) => f.folderCode === data.value
      );
      this.setState({
        currentCaseData,
        currentOption: {
          key: `case_${currentCaseData.folderCode}`,
          value: currentCaseData.folderCode,
          text: currentCaseData.folderName,
        },
      });
      localStorage.selectedFolderCode = currentCaseData.folderCode;
    } else {
      localStorage.selectedFolderCode = data.value;
      const currentOption = _.find(
        this.state.options,
        (o) => o.value === data.value
      );
      this.setState({ currentOption });
    }
  };

  updateCase = (caseData) => {
    this.setState({
      currentCaseData: caseData,
      currentOption: {
        key: `case_${caseData.folderCode}`,
        value: caseData.folderCode,
        text: caseData.folderName,
      },
    });
    localStorage.selectedFolderCode = caseData.folderCode;
  };

  render() {
    const { isLeftSearch } = this.props;
    return (
      <div>
        {isLeftSearch ? (
          <Table className="table-no-border">
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <CoverageArea
                    closeCoverageAreaDialog={this.closeCoverageAreaDialog}
                    openCoverageAreaDialog={this.openCoverageAreaDialog}
                    active={this.state.showCoverageDialog}
                    {...this.props}
                    isLeftSearch={isLeftSearch}
                  />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  <span className={"padding-right-10 medium-font"}>
                    Case Manager
                  </span>
                  {this.state.currentOption && (
                    <Dropdown
                      fluid
                      search
                      selectOnBlur={false}
                      selection
                      id="cmbLeftSearchCases"
                      className={"medium-font"}
                      style={{ minWidth: "auto !important" }}
                      value={this.state.currentOption.value}
                      options={
                        this.state.options === undefined
                          ? []
                          : this.state.options
                      }
                      onChange={(e, data) => this.caseChanged(e, data)}
                    />
                  )}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        ) : (
          <div className="margin-left-5">
            <Grid stackable style={{ marginRight: "-20px" }}>
              <Grid.Row>
                <Grid.Column>
                  <Segment>
                    <span className={"padding-right-10 medium-font"}>
                      Case Manager
                    </span>
                    {this.state.currentOption && (
                      <Dropdown
                        fluid
                        search
                        selectOnBlur={false}
                        selection
                        id="cmbCases"
                        className={"padding-right-10 medium-font"}
                        value={this.state.currentOption.value}
                        options={
                          this.state.options === undefined
                            ? []
                            : this.state.options
                        }
                        onChange={(e, data) => this.caseChanged(e, data)}
                      />
                    )}
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <CoverageArea
                    closeCoverageAreaDialog={this.closeCoverageAreaDialog}
                    openCoverageAreaDialog={this.openCoverageAreaDialog}
                    active={this.state.showCoverageDialog}
                    {...this.props}
                  />
                  <QuickTips
                    closeQuickTipsDialog={this.closeQuickTipsDialog}
                    openQuickTipsDialog={this.openQuickTipsDialog}
                    active={this.state.showQuickTipsDialog}
                    {...this.props}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        )}
        <Case
          dialogProps={{
            title:
              this.state.currentCaseData !== null
                ? this.state.currentCaseData.folderName
                : "New Case",
            data: this.state.currentCaseData,
          }}
          active={this.state.showCaseDialog}
          dialogClose={this.dialogClose}
          updateCase={this.updateCase}
          persistCaseSelection
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    uiData: state.uiData,
    userCases:
      state.userCases && state.userCases.userCases
        ? state.userCases.userCases
        : undefined,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(FormHeader);



// WEBPACK FOOTER //
// ./src/components/searches/FormHeader.js